import Button from "@/components/buttons/Button";
import DateRangeFilter from "@/components/filter/DateRangeFilter";
import Searchbox from "@/components/filter/Searchbox";
import SelectFilter from "@/components/filter/SelectFilter";
import Popup from "@/components/Popup";
import { FilterEnum } from "@/types";
import { ChevronDown, ListFilter } from "lucide-react";
import { useSearchParams } from "react-router-dom";


interface IProps {
    /**
     * Raw status values the list endpoint accepts. Omit on lists whose API has
     * no status filter — the control is then not rendered at all rather than
     * offering a filter that does nothing.
     */
    statusOptions?: Array<{ name: string, value: string }>
    /**
     * Only for lists whose API binds the date range as an ISO date
     * (LicenseFilterDTO uses LocalDate). ApplicationFilterDTO binds
     * java.util.Date with no format and rejects ISO input, so the investment
     * list leaves this off instead of shipping a filter that 400s.
     */
    showDateRange?: boolean
}

export default function ApplicationsFilters({ statusOptions, showDateRange }: IProps) {
    const [searchParams] = useSearchParams();

    const selected = searchParams.get(FilterEnum.STATUS);
    const selectedLabel = statusOptions?.find((item) => item.value === selected)?.name;

    return (
        <div className="flex items-center space-x-5 my-2 ml-1 ">
            <Searchbox
                placeholder="Search ID, customer name etc..."
            />

            {
                statusOptions && statusOptions.length > 0 &&
                <Popup
                    trigger={
                        <Button
                            type="button"
                            intent="secondary"
                            size="sm"
                            className="input-default py-3 w-[190px] justify-between"
                            rightIcon={<ChevronDown size={16} />}
                        >
                            {selectedLabel ?? "Select Status"}
                        </Button>
                    }
                >
                    <div className="w-96 bg-white border border-zinc-200 rounded-lg shadow-sm">
                        <h4 className="text-sm font-semibold border-b border-zinc-200 py-2 px-4">
                            Select filter
                        </h4>

                        <div className="flex flex-col space-y-4 divide-y divide-zinc-200">
                            <SelectFilter
                                label="Status"
                                name={FilterEnum.STATUS}
                                options={statusOptions} />
                        </div>
                    </div>
                </Popup>
            }

            {
                showDateRange &&
                <Popup
                    trigger={
                        <Button

                            type="button"
                            intent="secondary"
                            size="sm"
                            className="input-default py-3"
                            leftIcon={<ListFilter size={16} />}
                        >
                            Filter
                        </Button>
                    }
                >
                    <div className="w-96 bg-white border border-zinc-200 rounded-lg shadow-sm">
                        <h4 className="text-sm font-semibold border-b border-zinc-200 py-2 px-4">
                            Filter
                        </h4>

                        <div className="flex flex-col space-y-4 divide-y divide-zinc-200">
                            <DateRangeFilter />
                        </div>
                    </div>
                </Popup>
            }
        </div>
    )
}
